import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../store/store'
import { accountActions } from '../store/slices/accountSlice'
import { ACCOUNT_LOCKED_EVENT } from '../utils/password-expiration'

const useCheckUserProfile = (): void => {
  const dispatch = useDispatch()
  const clearUser = useSelector<RootState, boolean>((state) => state.account.clearUser)

  useEffect(() => {
    dispatch(accountActions.fetchProfile())
  }, [dispatch])

  useEffect(() => {
    const handleAccountLocked = () => {
      dispatch(accountActions.clearUserData())
    }

    window.addEventListener(ACCOUNT_LOCKED_EVENT, handleAccountLocked)
    return () => window.removeEventListener(ACCOUNT_LOCKED_EVENT, handleAccountLocked)
  }, [dispatch])

  useEffect(() => {
    if (clearUser) {
      dispatch(accountActions.clearUserData())
    }
  }, [clearUser, dispatch])
}

export default useCheckUserProfile
